import component from './details-specs.component'
import config from './details-specs.config'

const module = angular.module('mpa.pages.details.specs', [])

module.config(config).component('detailsSpecsPageComponent', component)

export default module.name
